import { createClient } from 'contentful';

const client = createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  environment: process.env.REACT_APP_CONTENTFUL_ENVIRONMENT,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
});

// Helper function to transform Contentful entry to blog post format
const transformBlogPost = (entry) => {
  const { fields, sys } = entry;
  
  // Handle featured image with better URL construction
  let featuredImage = null;
  if (fields.featuredImage && fields.featuredImage.fields && fields.featuredImage.fields.file) {
    const file = fields.featuredImage.fields.file;
    featuredImage = {
      url: file.url.startsWith('//') ? `https:${file.url}` : file.url,
      alt: fields.featuredImage.fields.description || fields.title || 'Blog post image'
    };
  }
  
  return {
    id: sys.id,
    slug: fields.shortName || sys.id, // Using shortName as preferred slug, fallback to entry ID
    shortName: fields.shortName || '',
    title: fields.title || 'Untitled Post',
    description: fields.description || '',
    content: fields.content || null, // Keep as rich text object
    publishedAt: sys.createdAt,
    author: fields.author || 'Andy Cary',
    tags: fields.categories || [],
    featuredImage: featuredImage,
    appRelease: fields.appRelease ? {
      appName: fields.appRelease.appName || '',
      version: fields.appRelease.version || '',
      downloadLink: fields.appRelease.downloadLink || ''
    } : null,
    seoKeywords: fields.seoKeywords || '',
    socialMediaSharing: fields.socialMediaSharing || false
  };
};

// Fetch all blog posts
export const getBlogPosts = async () => {
  try {
    const response = await client.getEntries({
      content_type: 'personalBlogPost',
      order: '-sys.createdAt'
    });
    
    return response.items.map(transformBlogPost);
  } catch (error) {
    return [];
  }
};

// Fetch a single blog post by shortName or ID
export const getBlogPost = async (shortName) => {
  try {
    // First try to find by shortName
    const response = await client.getEntries({
      content_type: 'personalBlogPost',
      'fields.shortName': shortName,
      limit: 1
    });
    
    if (response.items.length > 0) {
      return transformBlogPost(response.items[0]);
    }
    
    // Fallback: try to get by entry ID (for backward compatibility)
    try {
      const entry = await client.getEntry(shortName);
      return transformBlogPost(entry);
    } catch (entryError) {
      return null;
    }
  } catch (error) {
    return null;
  }
};

// Search blog posts
export const searchBlogPosts = async (query) => {
  try {
    const response = await client.getEntries({
      content_type: 'personalBlogPost',
      query: query,
      order: '-sys.createdAt'
    });
    
    return response.items.map(transformBlogPost);
  } catch (error) {
    return [];
  }
};

export default client; 